import React, { FC } from 'react';
import { useProjectConfigContext } from '../../../../../contexts/ProjectConfigContext';
import PermitType from '../../../../../types/permit.type';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import { usePermitRequestContext } from '../../../../../contexts/PermitRequestContext';
import useTags from '../../../../../hooks/useTags';
import addRequestPageLang from '../../../../../data/lang/add-request-page.lang';


type Props = {
  handleClick: (e: React.MouseEvent<HTMLInputElement>) => void
}

const GoldenAgePermit: FC<Props> = ({ handleClick }) => {

  const { projectConfigState } = useProjectConfigContext();
  const { Formik } = usePermitRequestContext();

  const { values } = Formik;
  const permitType = values.permitType;

  const permitTypes = projectConfigState.addRequestPageConfig.permitTypes;
  const hasGoldenPermit = permitTypes.golden;
  const gilHaZahavAge = projectConfigState.addRequestPageConfig.gilHaZahavAge;

  const generateTag = useTags();

  const label = generateTag(addRequestPageLang, 'form.permit-types.golden-age-permit.title-tag');
  const yesLabel = generateTag(addRequestPageLang, 'form.permit-types.golden-age-permit.options.yesLabel');
  const noLabel = generateTag(addRequestPageLang, 'form.permit-types.golden-age-permit.options.noLabel');

  if (!hasGoldenPermit) {
    return null;
  }


  return (
    <div className='row'>
      <div className='col-12 col-sm-4'>
        <RadioBtnsContainer label={`${label} (${gilHaZahavAge}+)`}>

          <RadioOutlineBtn
            isChecked={permitType !== PermitType.GOLDEN}
            label={noLabel}
            value={PermitType.REGULAR}
            onClick={handleClick}
            id="goldenPermitNo"
            name='goldenAgePermit'
          />

          <RadioOutlineBtn
            isChecked={permitType === PermitType.GOLDEN}
            label={yesLabel}
            value={PermitType.GOLDEN}
            onClick={handleClick}
            id="goldenPermitYes"
            name='goldenAgePermit'
          />

        </RadioBtnsContainer>
      </div>
    </div>
  );
}

export default GoldenAgePermit;